<template>
  <div>
    <custom-actions>
      <template #header>
        <el-button class="mr10" type="primary" v-if="hasAdd"
          @click="$router.push('/bondRecord/quickadd')">快捷充值</el-button>
        <!-- <el-button type="primary" v-if="hasAdd" @click="$router.push('/bondRecord/add')">新增</el-button> -->
        <el-dropdown v-if="hasJrAdd || hasAdd">
          <el-button type="primary">
            新增<i class="el-icon-arrow-down el-icon--right"></i>
          </el-button>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item v-if="hasAdd" @click.native="$router.push('/bondRecord/add')">保证金</el-dropdown-item>
            <el-dropdown-item v-if="hasJrAdd"
              @click.native="$router.push('/bondRecord/add?type=jr')">金融保证金</el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>

      </template>
      <el-form :model="searchForm" ref="formData" inline class="global-form-label-width account-form"
        label-width="100px">

        <el-form-item label="客户名称" prop="userName">
          <el-input clearable v-model="searchForm.userName" placeholder="请输入客户名称"></el-input>
        </el-form-item>
        <el-form-item label="流水凭证单号" prop="depositNumber">
          <el-input clearable v-model="searchForm.depositNumber" placeholder="请输入流水凭证单号"></el-input>
        </el-form-item>
        <el-form-item label="保证金类型" prop="depositType">
          <el-select filterable clearable v-model="searchForm.depositType" placeholder="请选择保证金类型">
            <el-option v-for="(item, index) of typeList" :value="item.value" :label="item.label"
              :key="index"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="审批状态" prop="approvalStatus">
          <el-select filterable clearable v-model="searchForm.approvalStatus" placeholder="请选择审批状态">
            <el-option v-for="(item, index) of statusList" :value="item.value" :label="item.label"
              :key="index"></el-option>
          </el-select>
        </el-form-item>

        <el-form-item>
          <el-button type="primary" @click="onSearch">查询</el-button>
          <el-button @click="onReset">重置</el-button>
        </el-form-item>
      </el-form>
    </custom-actions>

    <el-card shadow="never" class="mt10">
      <el-table size="mini" stripe border v-loading="loading" :data="tableData">
        <el-table-column min-width="120" label="客户名称" prop="userName"></el-table-column>
        <!-- <el-table-column min-width="180" label="流水ID" prop="depositId"></el-table-column> -->
        <el-table-column min-width="120" label="流水凭证单号" prop="depositNumber"></el-table-column>
        <el-table-column min-width="120" label="审批状态" prop="approvalStatus">
          <template v-slot="{ row }">
            <el-tag v-if="row.approvalStatus == '1'">待审批</el-tag>
            <el-tag type="success" v-if="row.approvalStatus == '2'">审批通过</el-tag>
            <el-tag type="danger" v-if="row.approvalStatus == '3'">审批驳回</el-tag>
          </template>
        </el-table-column>
        <el-table-column min-width="120" label="保证金类型" prop="depositType">
          <template v-slot="{ row }">
            {{ depositTypeMap.get(row.depositType) }}
          </template>
        </el-table-column>
        <el-table-column min-width="120" label="金额(元)" prop="depositChange"></el-table-column>
        <el-table-column min-width="160" label="创建时间" prop="ctime"></el-table-column>

        <el-table-column width="180" label="操作" fixed="right">
          <template v-slot="{ row }">

            <el-button type="text" @click="
              $router.push('/bondRecord/detail?depositId=' + row.depositId)
              ">详情</el-button>
            <!-- -->
            <el-button type="text" v-if='row.approvalStatus == 1 && hasApproval' @click="onApproval(row)">审批</el-button>

          </template>
        </el-table-column>
      </el-table>

      <el-pagination class="mt15" :current-page.sync="page" background layout="total, prev, pager, next" :total="total"
        @current-change="loadData">
      </el-pagination>
    </el-card>

    <!-- 审批 -->
    <ApprovalDialog urlType="1" :relatedId="rowId" v-if='showDlg' @closeDlg="showDlg = false" @successSave="loadData"
      :showDlg="showDlg"></ApprovalDialog>
  </div>
</template>

<script>
import keepAlive from '@/mixins/keepAlive'
import ApprovalDialog from '@/views/bondRecord/ApprovalDialog'
import { depositType } from '@/utils/dict'

export default {
  name: 'bondRecord',
  mixins: [keepAlive],
  components: { ApprovalDialog },

  data() {
    return {
      depositTypeMap: depositType,
      tableData: [],
      typeList: [
        {
          label: '充值',
          value: '1'
        },
        {
          label: '退还',
          value: '2'
        },
        {
          label: '转货款',
          value: '3'
        }
      ],
      statusList: [
        {
          label: '待审批',
          value: '1'
        },
        {
          label: '审批通过',
          value: '2'
        },
        {
          label: '审批驳回',
          value: '3'
        }

      ],

      page: 1,
      total: 0,
      loading: false,
      searchForm: {
        userName: '',
        depositType: '',
        approvalStatus: '',
        depositNumber: ''
      },

      userList: [],
      showDlg: false,
      rowId: ''

    }
  },
  computed: {
    buttonList() {
      return this.$store.state.buttonList.map(item => item.butCode)
    },
    hasAdd() {
      return this.buttonList.includes('add')
    },
    hasJrAdd() {
      return this.buttonList.includes('jradd')
    },
    hasApproval() {
      return this.buttonList.includes('approval')
    }
  },
  created() {
    this.loadUser()
    this.loadData()
  },

  methods: {
    onApproval(row) {
      this.rowId = row.depositId
      this.showDlg = true
    },
    loadUser() {
      this.$axios.get(this.$apis.system.selectSysUserByPage, { userType: '3' }).then(res => {
        this.userList = res.list || []
      })
    },

    loadData() {
      const params = {
        page: this.page,
        ...this.searchForm
      }
      console.log('params', params)
      this.$axios
        .get(this.$apis.bondRecord.selectYxUserDepositRecordByPage, {
          params: params
        })
        .then(res => {
          this.tableData = res.list
          this.total = res.total
        })
    },
    onSearch() {
      this.page = 1
      this.loadData()
    },
    onReset() {
      this.$refs.formData.resetFields()
      this.onSearch()
    }

  }
}
</script>
